import DoctorsContainer from 'modules/doctors/containers/DoctorsContainer';

const DoctorsView = props => <DoctorsContainer {...props} />;

export default DoctorsView;
